"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _misc = require("../utils/misc");

var _constants = require("../constants");

var legacyGetExistingClient = function legacyGetExistingClient(namespace) {
  var existingClient; // If RSW was already included on the page, the following will ensure that only
  // the first instance is used.

  var commandKey = (0, _misc.getCommandKey)(namespace);
  window[commandKey] = window[commandKey] || [];
  window[commandKey].push(function (client) {
    existingClient = client;
  });
  return existingClient;
};

var getExistingClient = function getExistingClient(namespace) {
  var existingClient;

  if (!(0, _misc.noWindow)()) {
    if (window._rswClients) {
      existingClient = window._rswClients[namespace || _constants.DEFAULT_NAMESPACE];
    }

    if (!existingClient) {
      existingClient = legacyGetExistingClient(namespace);
    }
  }

  return existingClient;
};

var _default = getExistingClient;
exports["default"] = _default;